import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/shared/material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CardHeaderComponent } from './card-header/card-header.component';
import { CardTitleComponent } from './card-title/card-title.component';
import { DetailPageHeaderComponent } from './detail-page-header/detail-page-header.component';
import { ListCalendarHeaderComponent } from './list-calendar-header/list-calendar-header.component';
import { MatLoadingCardComponent } from './mat-loading-card/mat-loading-card.component';
import { SaveBarComponent } from './save-bar/save-bar.component';
import { RouterModule } from '@angular/router';
import { RpSelectListComponent } from './select-list/select-list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		RouterModule,
	],
	declarations: [
		CardHeaderComponent,
		CardTitleComponent,
		DetailPageHeaderComponent,
		ListCalendarHeaderComponent,
		MatLoadingCardComponent,
		SaveBarComponent,
		RpSelectListComponent,
	],
	exports: [
		CardHeaderComponent,
		CardTitleComponent,
		DetailPageHeaderComponent,
		ListCalendarHeaderComponent,
		MatLoadingCardComponent,
		SaveBarComponent,
		RouterModule,
		RpSelectListComponent,
	],
})
export class CommonUiModule {}
